import { render, staticRenderFns } from "./Debug.vue?vue&type=template&id=635caa17&scoped=true&"
import script from "./Debug.vue?vue&type=script&lang=js&"
export * from "./Debug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635caa17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\camha\\projects\\netcountable-app\\truple\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('635caa17')) {
      api.createRecord('635caa17', component.options)
    } else {
      api.reload('635caa17', component.options)
    }
    module.hot.accept("./Debug.vue?vue&type=template&id=635caa17&scoped=true&", function () {
      api.rerender('635caa17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/debug/Debug.vue"
export default component.exports